import "styles/patient-dash.scss";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "react-bootstrap/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";



const PatientDashboard = () => {
  return (
    <div className="patient-dash-container">
      {/* Header Section */}
      <Box sx={{ textAlign: "center", mb: 4, mt: 3 }}>
        <Typography variant="h4" fontWeight={600}>
          Patient Dashboard
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Quick access to patient forms & profiles
        </Typography>
      </Box>

      {/* Cards Area */}
      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="center"
        sx={{ maxWidth: 900, margin: "0 auto" }}
      >
        {/* Registration Forms Card */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              padding: 2,
              borderRadius: 3,
              textAlign: "center",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
                transform: "translateY(-5px)",
              },
            }}
          >
            <CardActionArea href="/patient/intakes" sx={{ padding: 3 }}>
              <DescriptionRoundedIcon fontSize="large" color="primary" />
              <Typography variant="h6" sx={{ mt: 1 }}>
                View Registration Forms
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Access, review, and manage intake forms
              </Typography>
              <ArrowForwardRoundedIcon sx={{ mt: 2 }} />
            </CardActionArea>
          </Card>
        </Grid>

        {/* Patient Profiles Card */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              padding: 2,
              borderRadius: 3,
              textAlign: "center",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
                transform: "translateY(-5px)",
              },
            }}
          >
            <CardActionArea href="/patient/family" sx={{ padding: 3 }}>
              <GroupRoundedIcon fontSize="large" color="success" />
              <Typography variant="h6" sx={{ mt: 1 }}>
                View Patient Profiles
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Manage and update patient profile information
              </Typography>
              <ArrowForwardRoundedIcon sx={{ mt: 2 }} />
            </CardActionArea>
          </Card>
        </Grid>

        {/* Home Programs / Stim Reports Card */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              padding: 2,
              borderRadius: 3,
              textAlign: "center",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
                transform: "translateY(-5px)",
              },
            }}
          >
            <CardActionArea href="/patient/stim-reports" sx={{ padding: 3 }}>
              <AssignmentTurnedInRoundedIcon fontSize="large" color="secondary" />
              <Typography variant="h6" sx={{ mt: 1 }}>
                View Home Programs
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Access completed Stim Reports / Home Programs
              </Typography>
              <ArrowForwardRoundedIcon sx={{ mt: 2 }} />
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default PatientDashboard;